import axios from "axios";

export const defaultDropDown = [
  {
    id: 1,
    name: "Yes",
  },
  {
    id: 0,
    name: "No",
  },
];
export const routesDropDown = [
  {
    id: "C",
    name: "Category",
  },
  {
    id: "SC",
    name: "Sub Category",
  },
  {
    id: "P",
    name: "Product",
  },
];
export const preparationHours = [
   {
    id: 1,
    name: "1 Hours",
  },
  {
    id: 1,
    name: "1 Hour",
  },
  {
    id: 2,
    name: "2 Hours",
  },
  {
    id: 4,
    name: "4 Hours",
  },
  {
    id: 8,
    name: "8 Hours",
  },
  {
    id: 24,
    name: "24 Hours",
  },
];

export const parseArray = (dataArray) => {
  const uniqueValues = new Set(dataArray?.map((item) => item?.value));
  const result = Array.from(uniqueValues);
  return result;
};

const addLeadingZero = (value) => (value < 10 ? `0${value}` : value);

export const formatDate = (date) => {
  const day = addLeadingZero(date.getDate());
  const month = addLeadingZero(date.getMonth() + 1);
  const year = date.getFullYear();
  const hours = addLeadingZero(date.getHours());
  const minutes = addLeadingZero(date.getMinutes());
  const seconds = addLeadingZero(date.getSeconds());

  return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
};

export const parseStatusColor = (order_status) => {
  let bgColor;
  let textColor = "white";
  switch (order_status) {
    case "Submitted":
      bgColor = "#C51605";
      break;
    case "Confirmed":
      bgColor = "#ff7b00";
      break;
    case "Dispatched":
      bgColor = "#FFD700";
      textColor = "black";
      break;
    case "ReadyToDelivered":
      bgColor = "#80b918";
      break;
    case "Delivered":
      bgColor = "green";
      break;
    default:
      bgColor = "#000000"; // Default color if status doesn't match any case
      break;
  }
  return { bgColor, textColor };
};

export const setBaseURL = (url) => {
  sessionStorage.setItem("baseURL", url);
  axios.defaults.baseURL = url;
};

export const extractUniqueRegions = (data) => {
  const allRegions = data.flatMap((item) => item.region);

  const uniqueRegionsMap = new Map();

  allRegions.forEach((region) => {
    uniqueRegionsMap.set(region?.id, {
      id: region?.itemName?.region_id,
      name: region?.itemName?.city?.name,
    });
  });

  return Array.from(uniqueRegionsMap.values());
};
export const parseMessage = (message) => {
  return message
    ?.replace(/\*([^\*]+)\*/g, "<strong>$1</strong>") // Bold
    .replace(/_([^_]+)_/g, "<em>$1</em>") // Italic
    .replace(/~([^~]+)~/g, "<s>$1</s>") // Strikethrough
    .replace(/```([^`]+)```/g, "<code>$1</code>"); // Monospace
};
export function isNumeric(str) {
  return /^[0-9]+$/.test(str);
}
export const extractAfterLastUnderscore = (str) => {
  if (!str) return "";
  const parts = str.split("_");
  return parts[parts.length - 1];
};
